import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

GSAP.registerPlugin(ScrollTrigger)

export default class Hero {
	constructor(el) {

		this.element 	= el
		this.subtitle 	= this.element.querySelector('.hero__subtitle')
		this.video 		= this.element.querySelector('.hero__video')
		
		if (this.subtitle && this.element) {
			GSAP.set(this.subtitle, {opacity: 1});
			
			GSAP.to(this.subtitle, {
				scrollTrigger: {
				trigger: this.element,
				start: 'top top',
				end: '+=30px',
				// markers: true,
				scrub: true,
			},
				opacity: 0
			});
		}

		// GSAP.to(this.video, {
		// 	scrollTrigger: {
		// 		trigger: this.element,
		// 		start: 'top top',
		// 		// end: '+=30px',
		// 		markers: true,
		// 		scrub: true,
		// 		pin: true,
		// 	},
		// });

	}

}
